// utils/asset.ts
import { getRuntimeOrg } from '@/utils/runtimeOrg'; // your existing helper

const ORG_ENV = (process.env.NEXT_PUBLIC_ORG || '').trim();
const BASE_ENV = (process.env.NEXT_PUBLIC_BASE_PATH || '').trim();

function cleanSlash(s: string) {
  return s.replace(/\/{2,}/g, '/');
}

function trimEdges(s: string) {
  return s.replace(/^\/+/, '').replace(/\/+$/, '');
}

function normalizeOrg(org?: string) {
  const o = (org || ORG_ENV || '').toLowerCase().trim();

  return o || undefined;
}

/** Build basePath safely. Empty string means root (no base path). */
function getBasePath(): string {
  if (!BASE_ENV || BASE_ENV === '/') return '';

  // Ensure single leading slash, no trailing
  return '/' + trimEdges(BASE_ENV);
}

/** Join URL segments with exactly one slash between them. */
function joinUrl(...parts: Array<string | undefined>): string {
  const filtered = parts.filter(Boolean) as string[];

  if (filtered.length === 0) return '/';
  const first = filtered[0].startsWith('/') ? filtered[0] : '/' + filtered[0];
  const rest = filtered.slice(1).map((p) => trimEdges(p));

  return cleanSlash([first, ...rest].join('/'));
}

/**
 * Public path (no basePath), for use with next/image.
 * Ensures the org segment is present exactly once.
 * Example out: "/nyandarua/logo.png"
 */
export function imageSrc(path: string, org?: string): string {
  const o = normalizeOrg(org) || getRuntimeOrg();
  const p = trimEdges(path);
  const withOrg = p.startsWith(`${o}/`) ? p : `${o}/${p}`;

  return '/' + cleanSlash(withOrg);
}

/**
 * Full asset URL under current basePath, for plain tags, CSS, favicon, etc.
 * Example out (with base): "/dev/nyandarua/public/nyandarua/logo.png"
 * Example out (root): "/nyandarua/logo.png"
 */
export function asset(path: string, org?: string): string {
  const o = normalizeOrg(org) || getRuntimeOrg();
  const p = trimEdges(path);
  const withOrg = p.startsWith(`${o}/`) ? p : `${o}/${p}`;

  return joinUrl(getBasePath(), withOrg);
}
